module.exports = __webpack_public_path__ + "images/arrow-top-right-f47c1208fd7964dc2aced8f412cbc1e8.png";